<template>
  <div class="schedule">
    <p class="schedule__title h3">График работы</p>

    <div class="schedule__datepicker-wrapper">
      <p>Укажите дату</p>
      <BaseInput
        v-model="date"
        type="date"
        class="schedule__datepicker"
        @enter="fetchSchedule"
      />
      <BaseButton
        style="padding: 0 20px;"
        class="schedule__search"
        @click="fetchSchedule"
      >
        Поиск
      </BaseButton>
    </div>

    <AppTable
      v-if="tableItems.length"
      :fields="tableFields"
      :items="tableItems"
      class="schedule__table"
    >
      <template #createdBy="{ createdBy }">
        <BaseLink :href="`/user/${createdBy.id}`">
          {{ createdBy.name }} {{ createdBy.surname }}
        </BaseLink>
      </template>
    </AppTable>

    <p v-else class="h3">На данную дату матчи не назначены.</p>
  </div>
</template>

<script>
import moment from 'moment'
import AppTable from '@/components/AppTable'
import BaseLink from '@/components/Base/BaseLink'
import BaseInput from '../components/Base/BaseInput'
import BaseButton from '@/components/Base/BaseButton'

export default {
  name: 'schedule',
  components: {
    BaseButton,
    BaseInput,
    BaseLink,
    AppTable
  },
  data () {
    return {
      date: moment().format('YYYY-MM-DD'),
      tableFields: [
        { key: 'timeStart', label: 'Время с' },
        { key: 'timeStop', label: 'Время до' },
        { key: 'events', label: 'Событие' },
        { key: 'createdBy', label: 'Создатель', slot: true },
        { key: 'createdAt', label: 'Дата создания' },
        { key: 'status', label: 'Статус' }
      ],
      tableItems: []
    }
  },
  async created () {
    await this.fetchSchedule()
  },
  methods: {
    async fetchSchedule () {
      const { data } = await this.$api.schedule.list(this.date)

      const result = []
      const list = data.list ?? []
      /* Записал общее колво пользователей */

      for (const item of list) {
        result.push({
          id: item.id,
          timeStart: item.timeStart,
          timeStop: item.timeStop,
          events: item.events,
          createdBy: item.createdBy,
          createdAt: item.createdAt,
          status: item.status
        })
      }

      this.tableItems = result
    }
  }
}
</script>

<style lang="scss" scoped>
.schedule {
  &__title {
    margin-bottom: 30px;
  }

  &__datepicker-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }

  &__datepicker {
    display: inline-block;
    width: auto;
    margin-left: 20px;
  }

  &__search {
    margin-left: 10px;
  }
}
</style>
